import { useContext } from 'react';
import AddressFormContext from './AddressFormManagerContext';

const useAddressFormManagerContext = () => {
  const context = useContext(AddressFormContext);
  if (!context) {
    throw new Error(
      'useAddressFormManagerContext must be used within an useAddressFormManagerContext.Provider',
    );
  }
  return context;
};

export default useAddressFormManagerContext;
